<!--
 * @Author: andy_chen
 * @created: 2018-11-13 15:57:46
-->

<template>
    <div class="container">
        <list-item title="绑定手机号" :msg="phone" to="/bindPhone" :hasBottomLine="true" class="top-split-line"></list-item>
        <list-item title="登录密码" :msg="noPassword ? '未设置' : '已设置'" :to="noPassword ? `/updatePassword` : '/updatePassword?hasOldPwd=1'" :hasBottomLine="true" class="top-split-line"></list-item>
    </div>
</template>

<script>
import ListItem from "../components/ListItem";
import { getSecurityInfo } from "../api/user.js";
export default {
    name: "SafeSetting",
    components: {
        ListItem
    },
    data() {
        return {
            phone: "",
            noPassword: true
        };
    },

    created() {
        getSecurityInfo().then(res => {
            if (+res.code === 200) {
                let { phone, noPassword } = res.data;
                this.phone = phone;
                this.noPassword = noPassword;
            }
        });
    },

    computed: {},

    methods: {}
};
</script>

<style scoped lang="scss">
@import "../style/function.scss";
@import "../style/config.scss";

input {
    background: #ffffff;
    box-sizing: border-box;
    width: 100%;
    outline: none;
    border: none;
    // /*去除系统默认的样式*/
    -webkit-appearance: none;
    // /* 点击高亮的颜色*/
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.container {
    background: $baseBackgroundColor;
}

.top-split-line {
    margin-top: 0.1rem;
}
</style>
